<div class="origem-select dropdown"
    [class.invalid]="!config.isValid">
    <button class="btn btn-light dropdown-toggle" #dropdownToggle type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="origem">
            <span>
                <i class="{{origem.icon}}"></i>
                {{origem.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!origem">
            <span>
                Nenhuma Origem
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    [class.dropdown-item-select]="!idOrigem"
                    (click)="select(null)">
                    Nenhuma Origem
                </a>
                <a *ngFor="let item of origensOptions" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="item.id == idOrigem"
                    (click)="select(item)">
                    <i class="{{item.icon}}"></i>
                    {{item.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>